import { useTranslation } from 'react-i18next'

const BorderPoliceStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="borderpolice-start-title"
      {...props}
    >
      <title id="borderpolice-start-title">{t('antagonists:borderpolice:components:start')}</title>
      <defs>
        <clipPath id="borderpolice-start-b">
          <path
            d="M1483.15 277s14.27-17.38 43.87-17.34c29.61.04 37.95 13.14 37.95 13.14s-.52-24.02-7.81-34.64c-7.29-10.62-29.92-19.74-36.46-20.47-6.54-.73-27.1 16.08-31.51 21.87-4.42 5.8-7.29 35.85-6.04 37.43Z"
            style={{
              fill: '#31405d',
            }}
          />
        </clipPath>
        <style>
          {
            '.c,.d{fill:none}.e{fill:#b98743}.f{fill:#c48648}.g{fill:#c4c7c9}.h{fill:#b39746}.i{fill:#235a96}.j{fill:#1e2032}.k{fill:#222d44}.l{fill:#413f52}.m{fill:#9b4632}.n{fill:#31405d}.o{fill:#2f2b39}.p{clip-path:url(#borderpolice-start-b)}.d{stroke:#b39746;stroke-linejoin:round;stroke-width:1.59px}'
          }
        </style>
      </defs>
      <path
        d="M1483.2 275.22s-7.79 9.49-4.96 22.95c1.48 7.05 8.65 15.52 12.4 19.56 9.6 10.36 42.69 12.51 51.52 12.31s20.36-15.43 23.12-20.51 9.57-19.97 5.29-27.04c-4.28-7.06-5.11-7.62-6.62-14.94-1.52-7.32-20.29-29.11-39.89-28.58-19.6.53-37 25.25-40.86 36.24Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1485.93 924.8s1.55 27.79 2.04 36.14c.48 8.35-5.73 19.36-8.48 24.14-2.75 4.78-5.4 5.93-6.21 11.01-.81 5.08-.47 13.27-.47 13.27s49.01.1 48.56.06c-.45-.04 1.97-4.31 1.31-10.1-.66-5.8 1.24-11.39 3.67-18.01 2.43-6.62.11-16.92.13-25.84.01-8.92-3.43-33.53-3.43-33.53l-37.12 2.87Z"
        style={{
          fill: '#1e2032',
        }}
      />
      <path
        d="M1519.99 969.81s-7.51-2.33-13.61-1.85c-8.36.66-13.74 3.19-13.74 3.19l.14 2.74s5.61-2.75 13.73-2.71c8.12.04 12.76 1.97 12.76 1.97l.71-3.34ZM1519.7 963.25s-7.76-1.92-14.14-1.46c-6.11.43-13.05 3.2-13.05 3.2l.35 2.7s5.36-2.03 13.46-2.39c8.11-.37 12.84 1.33 12.84 1.33l.54-3.38ZM1520.87 956.59s-8.62-1.41-15.74-1.36c-6.5.05-13.19 2.46-13.19 2.46l.38 3.12s5.67-2.39 14.28-2.56c8.6-.16 13.54 1.59 13.54 1.59l.73-3.26ZM1520.89 948.98s-9.24-1.45-15.74-1.36c-9.02.13-13.24 3.33-13.24 3.33l.17 2.65s5.93-2.8 14.54-2.96c8.6-.16 13.54 1.59 13.54 1.59l.73-3.26ZM1521 942.15s-8.97-2.86-15.42-2.04c-6.44.82-13.24 3.33-13.24 3.33l.17 2.65s5.93-2.8 14.54-2.96c8.6-.16 13.54 1.59 13.54 1.59l.41-2.57Z"
        style={{
          fill: '#413f52',
        }}
      />
      <path
        d="M1614.4 921.19s-2.18 27.71-2.85 36.04c-.67 8.33 5.29 19.58 7.93 24.46 2.64 4.88 5.27 6.14 5.96 11.25.69 5.11-1.06 15.61-1.06 15.61s-48.32.46-47.87.44c.45-.02-1.32-9.01-.54-14.77.79-5.77-.98-11.44-3.26-18.14-2.27-6.71.27-16.92.46-25.83.19-8.91 4.19-33.37 4.19-33.37l37.04 4.32Z"
        style={{
          fill: '#1e2032',
        }}
      />
      <path
        d="M1579.32 964.84s7.56-2.04 13.65-1.32c8.34.99 13.66 3.73 13.66 3.73l-.21 2.73s-5.55-2.97-13.67-3.25c-8.12-.28-12.8 1.47-12.8 1.47l-.64-3.37ZM1579.76 958.29s7.8-1.61 14.17-.91c6.1.67 12.97 3.71 12.97 3.71l-.41 2.68s-5.31-2.24-13.41-2.92c-8.1-.68-12.87.83-12.87.83l-.47-3.4ZM1578.74 951.59s8.65-1.07 15.76-.73c6.5.31 13.13 2.98 13.13 2.98l-.45 3.1s-5.62-2.62-14.21-3.12c-8.6-.5-13.57 1.06-13.57 1.06l-.66-3.28ZM1578.89 943.99s9.27-1.09 15.76-.73c9.01.49 13.16 3.85 13.16 3.85l-.23 2.64s-5.87-3.03-14.47-3.54c-8.6-.5-13.57 1.06-13.57 1.06l-.66-3.28ZM1578.95 937.16s9.04-2.5 15.46-1.43c6.42 1.07 13.16 3.85 13.16 3.85l-.23 2.64s-5.87-3.03-14.47-3.54c-8.6-.5-13.57 1.06-13.57 1.06l-.35-2.59Z"
        style={{
          fill: '#413f52',
        }}
      />
      <path
        d="M1499.16 305.29s4.34 12.3 3.37 20.69c-.43 3.77-.44 13.78-14.56 22.6-10.73 6.7-32.48 23.71-32.48 23.71l68.49 18.43 73.9-39.11s-22.05-8.02-35.3-12.75c-8.54-3.05-8.47-12.76-8.35-17.81.28-10.89.69-20.53.69-20.53l-55.76 4.78Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1470.44 547.4s-28.5 118.77-18.8 169.82c9.71 51.05 11.75 79 13.54 100.98 1.79 21.98 1.05 30.5 1.25 57.66.16 22.19 11.81 44.11 12.72 50.13.91 6.03 5.46 23.98 5.46 23.98l42.43-2.49s14.67-10.18 11.59-42.19c-3.08-32-8.04-84.67-8.15-111.81-.11-27.14 2.97-81.17 9.08-130.99 6.1-49.82 6.05-116 6.05-116l-75.16.91Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="M1446.26 700.54s-9.29 28.63-3.97 44.81c5.32 16.18 14.47 30.38 14.47 30.38l15.47-.09-5.4-70.02-20.56-5.08ZM1446.61 676.62l-4.49 22.02 26.07 4.92 1.88-22.39-23.46-4.55z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1592.53 530.31s41.09 128.48 36.11 180.03c-4.98 51.55-4.44 79.53-4.2 101.54s10.18 41.87 4.99 63.39c-5.19 21.51-13.13 46.78-13.48 52.85-.35 6.07-1.6 13.68-1.6 13.68l-41.71 1.26s-13.56-6.83-13.44-38.92c.12-32.09.22-84.89-2.18-111.92-2.4-27.03-15.63-97.72-26.31-146.85-10.68-49.13-11.54-97.87-11.54-97.87l73.36-17.19Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="M1632.43 694.08s6.03 27.6 2.22 44.11c-3.82 16.51-5.88 25.62-5.88 25.62l-15.28 6.24.94-71.13 18-4.84ZM1630.54 669.84l5.87 21.28-25.55 6.87-3.93-22.14 23.61-6.01z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1388.38 624.51s-3.73 24.45-5.5 30.98c-1.77 6.53 18.61 25.75 18.9 25.61.3-.14 8.24 11.07 8.24 11.07s3.2-4.41 1.71-9.38c-1.48-4.97-5.77-7.37-5.22-16.05.55-8.69 1.69-18.4 4.77-18.04 3.08.36-.98 19.89.83 22.5 1.8 2.62 5.82 4.54 5.82 4.54s2.48-10.71 4.07-14.59c1.59-3.88 1.39-17.52.28-22.85-1.11-5.33-2.81-10.38-2.6-15.97.22-5.6 2.19-16.99 2.19-16.99l-31.15 1.01s.85 8.94-2.35 18.16ZM1687.83 609.46s4.99 22.75 6.79 29.26c1.79 6.51-16.28 26.72-16.58 26.58s-8.28 10.95-8.28 10.95-4.22-3.96-2.73-8.89c1.48-4.93 6.79-7.74 6.22-16.39-.57-8.65-1.74-18.33-4.84-18-3.1.33 1.02 19.8-.79 22.39s-5.86 4.46-5.86 4.46-2.52-10.69-4.13-14.56c-1.61-3.87-1.43-17.45-.32-22.74 1.11-5.29 2.81-10.3 2.59-15.88-.23-5.57 2.39-24.57 2.39-24.57l26.76 8.92s-4.44 9.25-1.21 18.46Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1493.13 262.88s2.85 20.02-.96 33.86c-1.76 6.39-.71 22.77 13.25 31.95 14.03 9.23 20.54 10.9 24.68 10.38 4.14-.52 12.72-5.66 18.52-9.61 5.8-3.95 13.51-21.8 12.11-28.99-1.64-8.42-4.9-24.72-5.86-28.72-.97-4-4.59-16.43-4.59-16.43l-26.64-1.74-30.51 9.3Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1495.49 284.36s-9.11-5.04-12.7-.93c-2.08 2.38 1.23 10.02 3.24 16.22 1.46 4.51 2.44 9 3.54 9.94 2.62 2.23 3.15-.99 5.09-1.94 1.93-.95 4.83-1.89 4.83-1.89l-4-21.4ZM1555.52 285.41s7.18-4.08 10.9-1.84c3.73 2.24-2.62 11-3.31 15.55-.69 4.54.41 7.72-3.31 8.93-3.73 1.21-7.73-.48-7.73-.48l3.45-22.16Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1532.45 279.54s3.72-4.24 6.88-5.63c4.79-2.11 10.58-.79 10.58-.79v-2.64s-8.48-1.78-13.5.3c-5.01 2.08-7.48 6.06-7.48 6.06l3.52 2.69ZM1515.34 279.89s-3.97-2.63-6.93-4.38c-3.91-2.31-9.58-.18-9.58-.18l-.59-2.34s7.72-2.56 12.87-.75 7.56 4.78 7.56 4.78l-3.33 2.87Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1483.15 277s14.27-17.38 43.87-17.34c29.61.04 37.95 13.14 37.95 13.14s-.52-24.02-7.81-34.64c-7.29-10.62-29.92-19.74-36.46-20.47-6.54-.73-27.1 16.08-31.51 21.87-4.42 5.8-7.29 35.85-6.04 37.43Z"
        style={{
          fill: '#31405d',
        }}
      />
      <g
        style={{
          clipPath: 'url(#borderpolice-start-b)',
        }}
      >
        <path
          d="M1519.04 225.55s-5.63 2.8-5.35 4.98c.28 2.18 1.92 2.28 1.92 2.28s-3.03 1.33-2.74 4.77c.29 3.44 2.74 8.26 5.15 9.46 2.4 1.2 3.7-.69 3.7-.69s1.92 1.65 4.11-.51c2.2-2.15 2.79-6.95 2.5-10.03-.29-3.08-4.09-3.93-4.09-3.93s1.05-1.44.54-2.98-5.74-3.36-5.74-3.36Z"
          style={{
            fill: '#b39746',
          }}
        />
        <path
          d="M1515.63 234.62s1.63-1.43 4.34-1.59c2.72-.16 4.37.49 4.37.49s1.57 10.5-3.07 10.38c-5.35-.14-5.64-9.29-5.64-9.29Z"
          style={{
            fill: '#235a96',
          }}
        />
        <path
          d="m1490.83 233.31 8.89-.46s-4.78 10.38 2.12 12.46c7.17 2.16 12.05-.2 20.52-.58 8.48-.38 19.49-.09 21.36-4.15 2.86-6.24-3.64-11.59-3.64-11.59l8.81-2.31"
          style={{
            fill: 'none',
            stroke: '#b39746',
            strokeLinejoin: 'round',
            strokeWidth: '1.59px',
          }}
        />
      </g>
      <path
        d="M1512.6 318.82c1.26 1.69 2.76-1.36 5.11.73s6.76 3.64 10.63 3.67c7.59.06 9.69-5.34 10.9-5.56 2.21-.4 3.04.71 3.73-1.07s-8.42-5.58-11.18-5.47c-2.76.12-3.31 1.63-4.42 1.62-1.1 0-1.52-2.36-4.55-1.42-3.04.94-12.28 4.72-10.21 7.5Z"
        style={{
          fill: '#9b4632',
        }}
      />
      <path
        d="m1508.35 283.79-7.64.04-.11-1.92 8.89-.99s-.96 2.9-1.14 2.87Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1508.64 282-7.78-2.65.34-1.99 8.2 2.54-.76 2.1z"
      />
      <path
        d="M1509.32 279.23c-1.96.62-2.9 2.38-2.2 4.28.7 1.89 2.59 2.52 4.37 2.07 2.11-.53 2.61-2.42 2.09-4.44-.37-1.43-2.25-2.56-4.26-1.92ZM1539.14 282.86l7.51-.6-.06-1.92-8.84-.26s1.22 2.82 1.39 2.78Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1538.69 281.09 7.52-3.2-.52-1.96-7.94 3.13.94 2.03z"
      />
      <path
        d="M1537.77 278.38c2 .48 3.1 2.17 2.57 4.11-.53 1.94-2.35 2.7-4.18 2.38-2.15-.38-2.81-2.22-2.47-4.27.24-1.45 2.01-2.71 4.08-2.22Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1500.68 338.58s.44 9.64 9.99 16.45c9.55 6.81 19.66 10.82 19.66 10.82s13.1-6.02 19.54-11.59c9.41-8.15 9.65-18.25 9.65-18.25s14.06 6.08 29.23 10.69c15.17 4.61 35.67 14.09 40.17 24.78 4.49 10.69-20.51 123.41-17.59 162.62 2.69 36.16-3.84 49.89-3.84 49.89l-140.19.49s-14.92-2.58-7.06-48.51-33.93-150.1-22.28-160.3c9.84-8.62 31.29-17.2 42.48-24.1 11.3-6.96 20.24-12.99 20.24-12.99Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="m1459.76 576.91-2.44 29.91s38.81 9.81 79.47 10.14 77.4-11.35 77.4-11.35l-4.02-27.66s-25.99 8.06-64.67 8.23c-38.67.18-85.73-9.28-85.73-9.28Z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1607.12 355.55c29.08.48 43.26 53.96 56.27 82.01 12.53 27.03 32.12 80.54 35.58 101.3 2.85 17.08-8.4 52.38-8.4 52.38l-1.52 16.41-31.09-1.09s-5.33-8.46-11.66-49.4c-6.32-40.86-24.09-67.14-36.94-91.89-8.82-16.98-29.94-29.13-34.91-46.37-4.97-17.24 10.09-63.72 32.68-63.35Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1552.66 423.97-.32 17.54 51.01 4.01-.07-18.57-50.62-2.98z"
      />
      <path
        style={{
          fill: '#b39746',
        }}
        d="m1556.99 428.33-.6 8.81 42.34 2.75.2-8.41-41.94-3.15z"
      />
      <path
        d="M1495.18 643.18c-.77 5.27-4.14 9.89-12.47 8.8-7.84-1.03-9.18-7.54-8.85-11.55.32-4.01 4.15-9.61 10.86-9.31 7.73.34 11.22 6.87 10.46 12.06Zm-10.53-8.08c-4.17-.19-6.55 3.29-6.75 5.79-.2 2.49.63 6.54 5.5 7.18 5.18.68 7.28-2.19 7.75-5.47.47-3.22-1.7-7.28-6.5-7.49Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        style={{
          fill: '#c4c7c9',
        }}
        d="m1482.38 615.82-.94 17.22 7.8.77.7-16.51-7.56-1.48z"
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1478.38 575.69-4.46 48.32 23.39 2.65 2.53-49.02-21.46-1.95z"
      />
      <path
        d="M1480.02 645.7s0 22.11-.34 26.46 2.35 11.41 8.72 10.46c6.37-.95 9.06-3.28 9.39-10.31.34-7.03-8.72-27.54-8.72-27.54l-9.06.93Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1454.51 366.99c-36.04 2.55-47.58 73.68-56.19 102.12-7.31 24.13-15.28 69.63-18.05 86.82-3.53 21.89 4.62 40.14 4.62 40.14l1.73 27.65 34.15-3.47s2.7-7.19 10.18-47.82c4.93-26.79 5.49-38.92 10.39-57.32 6.28-23.59 26.02-65.5 29.96-83 3.95-17.5 5.66-66.69-16.79-65.11Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="m1502.3 329.7-9.32 5.91-22.27 36.65s33.57-4.37 45.47-4.37c11.9 0 15.37.99 15.37.99s16.37-4.96 23.8-2.48c7.44 2.48 29.76 3.47 29.76 3.47l-19.84-33.72-10.41-6.94s0 18.85-7.44 24.8c-7.44 5.95-17.36 11.41-17.36 11.41s-18.85-6.94-23.8-15.87c-4.96-8.93-3.97-19.84-3.97-19.84Z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1441.61 369.64 4.97 9.41 37.51-19.59 1.12-10.92-10.08 1.68-33.52 19.42zM1618.2 358.06l-4.17 9.79-39.02-16.41-2.94-10.22 11.11.27 35.02 16.57zM1511.33 451.26s1.6 29.97 2.24 37.02c.64 7.04-1.92 10.86-13.46 12.69-11.53 1.82-19.81 4.42-27.5 2.44-7.69-1.98-9.65-10.51-10.42-21.38-.77-10.89-2.62-20.92-2.62-20.92l51.76-9.84ZM1456.89 437.43l52.84-6.13s4.49 13.47.64 16.64c-3.84 3.17-47.91 10.8-50.35 7.81-4.02-4.94-3.13-18.32-3.13-18.32ZM1530.99 384.61c-2.68-.12-4.21 2.11-4.33 3.72-.13 1.6.41 4.2 3.54 4.61 3.33.44 4.67-1.41 4.98-3.51.3-2.07-1.09-4.68-4.18-4.81ZM1533.85 433.37c-2.68-.12-4.21 2.11-4.33 3.72-.13 1.6.41 4.2 3.54 4.61 3.33.44 4.67-1.41 4.98-3.51.3-2.07-1.09-4.68-4.18-4.81ZM1535.2 489.99c-2.68-.12-4.21 2.11-4.33 3.72-.13 1.6.41 4.2 3.54 4.61 3.33.44 4.67-1.41 4.98-3.51.3-2.07-1.09-4.68-4.18-4.81ZM1535.68 536.62c-2.68-.12-4.21 2.11-4.33 3.72s.41 4.2 3.54 4.61c3.33.44 4.67-1.41 4.98-3.51.3-2.07-1.09-4.68-4.18-4.81Z"
      />
    </svg>
  )
}

export default BorderPoliceStart

